<template>
  <div class="w_100per h_100per agreeservice-container">
    <!-- agreeservice-header -->
    <div class="agreeservice-header">
      <!-- aplayzlogo -->
      <router-link class="aplayzlogo-wrap" :to="{ path: '/home' }">
        <img
          class="aplayzlogo"
          src="/media/images/logo/aplayz-logo-red.png"
          alt="/media/images/logo/aplayz-logo-red.png"
        />
      </router-link>
    </div>

    <!-- agreeservice-contents -->
    <div class="agreeservice-contents">
      <div class="max1200-container policy-container">
        <PolicyBox :tab="selectTab" />
      </div>
    </div>
  </div>
</template>
<script>
import PolicyBox from '@/components/Policy/PolicyBox.vue';
export default {
  components: {
    PolicyBox
  },
  created() {
    const { type } = this.$route.params;
    if (type === 'service') {
      this.selectTab = 1;
    } else {
      this.selectTab = 2;
    }
  },
  data() {
    return {
      selectTab: 1
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped src="@/assets/css/agreeservice/agreeservice.css"></style>
